import api from "../../services/api";
import { toast } from "react-toastify";

export async function uploadFile(props) {
  const { file, key, token, prefix = "" } = props;
  if (!file) return;
  try {
    let _body = new FormData();
    _body.append("file", file);
    const _response = await api.post(`${prefix}files`, _body, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        ...(!!key ? { [key]: 1 } : {}),
        size: file?.size || 0,
      },
    });
    return _response;
  } catch (__error) {
    toast.error("Problemas ao subir o arquivo.");
    console.log("__error", __error);
  }
}
